import "./reset.css";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import { AnimatePresence } from "framer-motion";
import React from "react";
import ReactDOM from "react-dom";
import Modal from "react-modal";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { authDaemon } from "./AuthDaemon";
import { setupInterceptors } from "./maxios/interceptors";
import { domainProvider } from "./utils/domainProvider";

domainProvider.debugging({
  isLiveEnv: process.env.REACT_APP_VERCEL_ENV === "live",
});

Modal.setAppElement("#root");

// HTTP 인터셉터 초기화 (인증, 로깅 등)
setupInterceptors();

authDaemon();

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <BrowserRouter>
    <AnimatePresence exitBeforeEnter>
      <App />
    </AnimatePresence>
  </BrowserRouter>,
  document.getElementById("root")
);

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("./service-worker.js");
}
